import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IThinkAnalyticsRepository } from '../../repositories/interfaces/IThinkAnalyticsRepository';
import { IThinkAnalyticsGetMoreLikeThisResponse } from '../../../entity/interface/iThinkAnalytics';

export interface IGetVodListAndYouWatchedUseCase {
    execute(apiKey: string, token: string, queryParams: any): Promise<IThinkAnalyticsGetMoreLikeThisResponse>;
}

export class GetVodListAndYouWatchedUseCase implements IGetVodListAndYouWatchedUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getVodListAndYouWatchedRepository(): IThinkAnalyticsRepository {
        return container.resolve<IThinkAnalyticsRepository>(DI.REPOSITORIES.IThinkAnalyticsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, token: string, queryParams: any): Promise<IThinkAnalyticsGetMoreLikeThisResponse> {
        return this.getVodListAndYouWatchedRepository.getVodListAndYouWatched(apiKey, token, queryParams);
    }
}
